/**
 * created by  yxy
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import TextBtn from "./TextBtn";
import {Button, Modal, Input} from "antd";
import InputMark from "./InputMark";
import BaseComponent from "../../../../base/BaseComponent";
import {uuid} from "../../../../utils";
const {TextArea}=Input;
export default class DialogBtn extends Component {
    static defaultProps = {
        okText:"确定",
        cancelText:"取消",
        modalTitle:'操作'
    };
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            visible:false,
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    getBtn(){
        let btn=this.props.btn;
        let mLeft = btn.mLeft ||'';
        if(btn.type == 'button') {
            return (<Button style={{color: "#fff ", background: "#0050B3",marginLeft:mLeft?mLeft:""}} onClick={()=>{
                this.btnClick(this.props.record)
            }} >{this.props.btnText}</Button>)
        }
        return (<TextBtn btnClick={()=>{
            this.btnClick(this.props.record)
        }} btnText={this.props.btnText} />)
    }

    render() {
        let btn = this.getBtn();
        return (
            <div>
                {btn}
                {this. renderModal()}
            </div>
        )
    }

    renderModal(){
        let btn=this.props.btn;
        let isRefresh = btn.execOverRefresh;
        let content=<div>未配置弹窗内容组件</div>;
        if(btn.content === "inputMark"){
            content = <InputMark complete={()=>{
                this.complete()
            }} sysConfigKeyParamsVal={btn.configKey} closeDialog={()=>{
                this.closeDialog();
            }} record={this.props.record} ref={(InputMark)=>{this.connectChild=InputMark}}/>
        }
        return (
            <Modal
                title={
                    <div >{this.props.modalTitle}</div>
                }
                style={{top: 20}}
                visible={this.state.visible}
                onOk={() => this.setState({visible: false})}
                onCancel={() => this.setState({visible: false})}
                centered={true}
                width={400}
                height={256}
                footer={
                    <div style={{textAlign: "center"}}>
                        {this.props.btn&&this.props.btn.cancelText?<Button onClick={() =>this.cancel()}>{this.props.btn&&this.props.btn.cancelText}</Button>:null}
                        {this.props.okText?<Button onClick={() => {this.save()}} style={{background: "#0050B3", color: "#fff"}}>{this.props.okText}</Button>:null}
                    </div>
                }
            >
                <div key={uuid()}>
                    {
                        content
                    }
                </div>
            </Modal>
        )
    }
    closeDialog() {
        this.setState({visible: false})
    }

    btnClick(record) {
        this.setState({visible: true})
    }

    cancel(){
        let btn=this.props.btn;
        if(this.connectChild[btn.cancelFunctionName]){
            this.connectChild[btn.cancelFunctionName]()
        }else{
            this.setState({visible:false})
        }
    }

    save(){
        let btn=this.props.btn;
        if(this.connectChild[btn.okFunctionName]){
            this.connectChild[btn.okFunctionName]()
        }else{
            this.complete();
        }
    }

    complete(){
        let btn=this.props.btn;
        let isRefresh = btn.execOverRefresh;
        this.setState({visible:false},()=>{
            if(isRefresh){
                this.props.refresh&&this.props.refresh()
            }
        })
    }


}